var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.counter > 0)?_c('span',{staticClass:"Counter",domProps:{"textContent":_vm._s(_vm.counter)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }